const resource = {
    resource_identifier_in_use: 'API識別子 {{indicator}} はすでに使用されています',
};
export default resource;
